module.exports = __webpack_public_path__ + "static/media/sitemap_v_3_arabic.8580ada4.svg";